import localConfig from "../configs/config.json";
import versionInfo from "../configs/versionInfo.json";

export const getConfig = _ => {
  /**
   * In dev, the CRA dev server can proxy same-origin `/api/*` requests to a local backend
   * (see `src/setupProxy.js`). Rewriting URLs to `http://localhost:5000/api/*` bypasses that
   * proxy and triggers CORS errors.
   *
   * If you *want* to bypass the proxy and call the backend directly, opt in with:
   *   REACT_APP_DIRECT_LOCAL_API=true
   * and optionally:
   *   REACT_APP_LOCAL_API_BASE=http://localhost:5000
   */
  const directLocalApi = process.env.REACT_APP_DIRECT_LOCAL_API === "true";
  const localApiBase = process.env.REACT_APP_LOCAL_API_BASE || "https://beta.plexsearch.com";

  if (localConfig.env === "dev" && directLocalApi && !localConfig.patched) {
    const api = localConfig.ExternalRESTAPI;
    Object.entries(api).forEach(([k, v]) => {
      api[k] = v.replace(/^\/api\//, `${localApiBase.replace(/\/$/, "")}/api/`);
    });
    localConfig.patched = true;
  }
  return localConfig;
};

export const getEnv = () => getConfig().env;

export const DEV = process.env.NODE_ENV === 'development';
export const BETA = getConfig().cell === "beta";
export const SSO_ENABLED = ["beta", "dev"].includes(getConfig().cell);

export const getVersionInfo = () => versionInfo;
